import script from "./TableForJoinCampaignBulk.vue?vue&type=script&setup=true&lang=js"
export * from "./TableForJoinCampaignBulk.vue?vue&type=script&setup=true&lang=js"

import "./TableForJoinCampaignBulk.vue?vue&type=style&index=0&id=15fd10d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15fd10d6"]])

export default __exports__